import React from 'react';
import {buildParams} from './helper';
import styled from 'styled-components';
import SharedSearchResultInterface from "./SharedSearchResultInterface";

const SearchList = (props) => {
    const {filterParams, setFilterParams, settings} = props;
    const [page, setPage] = React.useState(1);
    const [entriesPerPage, setEntriesPerPage] = React.useState(25);
    const [workplaces, setWorkplaces] = React.useState([]);
    const [totalResults, setTotalResults] = React.useState();

    React.useEffect(() => {
        fetch(
            props.settings.wpFastsearchServer
            + '/api/search/'
            + props.settings.wpFastsearchToken
            + '/workplace?'
            + buildParams(filterParams, page, entriesPerPage),
        ).then((response) => {
            response.json().then((parsed) => {
                setWorkplaces(parsed.items);
                setTotalResults(parsed.total_count);
            });
        });
    }, [filterParams, page, entriesPerPage]);

    return <div>
        <SharedSearchResultInterface totalResults={totalResults}
                         settings={props.settings}
                         defaultFilterParams={props.defaultFilterParams}
                         filterParams={props.filterParams}
                         setFilterParams={props.setFilterParams}
                         currentViewIsMap={props.currentViewIsMap}
                         setCurrentViewIsMap={props.setCurrentViewIsMap}
                         isSearchFormVisible={props.isSearchFormVisible}
                         setIsSearchFormVisible={props.setIsSearchFormVisible} />
        <WorkplaceResultBox>
            <WorkplaceListPagination page={page} setPage={setPage} totalResults={totalResults} entriesPerPage={entriesPerPage}/>
            {workplaces.map((workplace) => <WorkplaceListEntry key={workplace.id} workplace={workplace}/>)}
            <WorkplaceListPagination page={page} setPage={setPage} totalResults={totalResults} entriesPerPage={entriesPerPage}/>
        </WorkplaceResultBox>
    </div>;
};

const WorkplaceListPagination = (props) => {
    const {page, setPage, totalResults, entriesPerPage} = props;
    const lastPage = Math.ceil(totalResults / entriesPerPage);

    return <WorkplaceListEntryContainer>
        <PaginationButton onClick={() => setPage(1)} title="Zur ersten Seite springen" disabled={page === 1}>&laquo;</PaginationButton>
        <PaginationButton onClick={() => setPage(page - 1)} title="Vorige Seite" disabled={page === 1}>&lsaquo;</PaginationButton>
        <PaginationPage>Seite {page} | {lastPage}</PaginationPage>
        <PaginationButton onClick={() => setPage(page + 1)} title="Nächste Seite" disabled={page === lastPage}>&rsaquo;</PaginationButton>
        <PaginationButton onClick={() => setPage(lastPage)} title="Zur letzten Seite springen"
                          disabled={page === lastPage}>&raquo;</PaginationButton>
    </WorkplaceListEntryContainer>;
};

const WorkplaceResultBox = styled.div`
    max-width: 1420px;
    margin: 0 auto;
`;

const PaginationButton = styled.button`
    border: none;
    background-color: transparent;
    color: rgb(0 64 49);
    font-size: 1.8rem;
    width: 28px;

    &:disabled {
        color: gray;
    }
`;

const PaginationPage = styled.span`
    display: inline-block;
    padding: 6px 10px 0 10px;
`;

const serviceDescriptions = {
    foej: 'FÖJ',
    oebfd: 'ÖBFD',
    foej_and_oebfd: 'FÖJ & ÖBFD',
}


const WorkplaceListEntry = (props) => {
    const {workplace} = props;
    return <WorkplaceListEntryContainer>
        <h3><a href={props.workplace.url} target={'_blank'}>{workplace.title}</a></h3>
        <WorkplaceListEntryInfo>
            {workplace.address.split(',').map((component, i) => <React.Fragment key={i}>{component}<br /></React.Fragment>)}
        </WorkplaceListEntryInfo>
        <WorkplaceListEntryInfo>
            {workplace.work_category && workplace.work_category.map((category) => <span key={category}>{category}<br/></span>)}
        </WorkplaceListEntryInfo>
        <WorkplaceListEntryInfo>
            {!!workplace.service && serviceDescriptions[workplace.service]}
        </WorkplaceListEntryInfo>
    </WorkplaceListEntryContainer>;
};

const WorkplaceListEntryContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    color: rgb(0 64 49);
    background-color: rgb(185 205 178);
    padding: 0 3rem 1rem 3rem;
    font-size: 0.9rem;

    &:nth-child(odd) {
        background-color: rgb(203 219 189)
    }

    & h3 {
        width: 100%;
        font-size: 1.8rem;
    }
    & a, a:hover, a:visited, a:active {
        color: rgb(0 64 49);
    }

    &:first-child {
        border-top-left-radius: 50px;
        border-top-right-radius: 50px;
        padding-top: 25px;
    }

    &:last-child {
        border-bottom-left-radius: 50px;
        border-bottom-right-radius: 50px;
        padding-bottom: 25px;
    }


    @media (min-width: 900px) {
        padding-right: 480px;
    }
`;

const WorkplaceListEntryInfo = styled.div`
    width: 30%;
`;

export default SearchList;
